/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Help_Article_Import_Export_DescriptionInputs */



/**
* | output |
* | --- |
* | "Move collections between OpenRift and other Riftbound tools (Piltover Archive, RiftCore, and more) using CSV." |
*
* @param {Help_Article_Import_Export_DescriptionInputs} inputs
* @param {{ locale?: "en" | "de" | "fr" | "zh-Hans" | "zh-Hant" | "ko" }} options
* @returns {LocalizedString}
*/
export const help_article_import_export_description = /** @type {((inputs?: Help_Article_Import_Export_DescriptionInputs, options?: { locale?: "en" | "de" | "fr" | "zh-Hans" | "zh-Hant" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Help_Article_Import_Export_DescriptionInputs, { locale?: "en" | "de" | "fr" | "zh-Hans" | "zh-Hant" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Verschiebe Sammlungen per CSV zwischen OpenRift und anderen Riftbound-Tools (Piltover Archive, RiftCore und mehr).")
	if (locale === "fr") return /** @type {LocalizedString} */ ("Transférez des collections entre OpenRift et d'autres outils Riftbound (Piltover Archive, RiftCore et d'autres) via CSV.")
	if (locale === "zh-Hans") return /** @type {LocalizedString} */ ("用 CSV 在 OpenRift 与其他 Riftbound 工具（Piltover Archive、RiftCore 等）之间搬运收藏。")
	if (locale === "zh-Hant") return /** @type {LocalizedString} */ ("透過 CSV 在 OpenRift 與其他 Riftbound 工具（Piltover Archive、RiftCore 等）之間搬移收藏。")
	if (locale === "ko") return /** @type {LocalizedString} */ ("CSV로 OpenRift와 다른 Riftbound 도구(Piltover Archive, RiftCore 등) 사이에서 컬렉션을 옮기세요.")
	return /** @type {LocalizedString} */ ("Move collections between OpenRift and other Riftbound tools (Piltover Archive, RiftCore, and more) using CSV.")
});